import { messageOfUnknownError } from '../../utils/utils.js';

function pickMessage(message, error) {
    return message ? message : messageOfUnknownError(error);
}
class PaymentError extends Error {
    retryable = false;
    originalMessage = undefined;
    constructor({ message, retryable, error, }) {
        super(pickMessage(message, error));
        if (error instanceof Error) {
            this.stack = error.stack;
            this.originalMessage = error.message;
        }
        this.retryable = !!retryable;
        Object.setPrototypeOf(this, PaymentError.prototype);
    }
}

export { PaymentError as default, pickMessage };
//# sourceMappingURL=PaymentError.js.map
